import React, { createContext, useContext, useEffect, useState } from "react";

// Create context
const ScanContext = createContext();

// Custom hook
export const useScan = () => useContext(ScanContext);

// Provider
export const ScanProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    const stored = localStorage.getItem("scanned_items");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem("scanned_items", JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.sku === item.sku);
      if (exists) {
        return prev.map((i) =>
          i.sku === item.sku ? { ...i, qty: i.qty + item.qty } : i
        );
      }
      return [...prev, item];
    });
  };

  const clearItems = () => {
    setItems([]);
    localStorage.removeItem("scanned_items");
  };

  const updateItemQty = (sku, qty) => {
    setItems((prev) =>
      prev.map((item) => (item.sku === sku ? { ...item, qty } : item))
    );
  };

  const deleteItem = (sku) => {
    setItems((prev) => prev.filter((item) => item.sku !== sku));
  };

  return (
    <ScanContext.Provider
      value={{ items, setItems, addItem, clearItems, updateItemQty, deleteItem }}
    >
      {children}
    </ScanContext.Provider>
  );
};
